import { Divider } from "antd";
import { useAtom } from "jotai";
import {
  chargesAtom,
  deleteChargeAtom,
  updateChargeAtom,
  addChargeAtom,
  getBillSubTotalAtom,
  getTotalItemDiscountsAtom,
  getTotalBillDiscountAtom,
} from "../../helpers/state/bill";
import { Loader } from "@mantine/core";
import { useEffect } from "react";
import ChargeLineItem from "./charge-line-item";

export default function AddChargesComponent({ allCharges = [] }) {
  const [charges, setCharges] = useAtom(chargesAtom);
  const [, deleteCharge] = useAtom(deleteChargeAtom);
  const [, updateCharge] = useAtom(updateChargeAtom);
  const [, addCharge] = useAtom(addChargeAtom);
  const [billSubTotal] = useAtom(getBillSubTotalAtom);
  const [totalItemDiscounts] = useAtom(getTotalItemDiscountsAtom);
  const [totalBillDiscount] = useAtom(getTotalBillDiscountAtom);

  // Calculate subtotal before charges using existing atoms
  const billSubTotalBeforeCharges =
    billSubTotal - totalItemDiscounts - totalBillDiscount;

  // Get available charges (not already selected)
  const availableCharges = allCharges.filter(
    (charge) =>
      !charges.some((selectedCharge) => selectedCharge.chargeId === charge.id)
  );

  const handleAddCharge = () => {
    addCharge({
      chargeId: null,
      value: 0,
    });
  };

  // Recalculate all charge values when bill subtotal changes
  useEffect(() => {
    if (charges.length > 0) {
      charges.forEach((charge) => {
        if (charge.chargeId) {
          const selectedCh = allCharges.find((ch) => ch.id === charge.chargeId);
          if (selectedCh) {
            let newValue = 0;
            if (selectedCh.valueType === "fixed") {
              newValue = selectedCh.value;
            } else if (selectedCh.valueType === "percentage") {
              newValue = (billSubTotalBeforeCharges * selectedCh.value) / 100;
            }

            // Only update if the value has changed
            if (Math.abs(newValue - charge.value) > 0.01) {
              updateCharge({
                id: charge.id,
                value: newValue,
              });
            }
          }
        }
      });
    }
  }, [billSubTotalBeforeCharges, charges, allCharges, updateCharge]);

  return (
    <div>
      {allCharges.length === 0 ? (
        <span className="mt-4">
          <Loader /> <span className="ms-2">Loading charges...</span>
        </span>
      ) : (
        <>
          <Divider className="my-2" />
          <div className="row">
            <div className="col-md-6">Charge</div>
            <div className="col-md-4">Value</div>
            <div className="col-md-2"></div>
          </div>
          <Divider className="my-2" />

          <div className="row align-items-center">
            {charges?.map((charge) => (
              <ChargeLineItem
                key={charge.id}
                charge={charge}
                allCharges={allCharges}
                availableCharges={availableCharges}
                billSubTotalBeforeCharges={billSubTotalBeforeCharges}
                onDelete={deleteCharge}
                onUpdate={updateCharge}
              />
            ))}
          </div>

          {availableCharges.length > 0 && (
            <button
              className="button is-ghost"
              autoFocus
              onClick={handleAddCharge}>
              <span className="bi bi-plus-circle me-2"></span>
              Add Charge
            </button>
          )}
        </>
      )}
    </div>
  );
}
